import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';

import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { ActionsApiService, BrandCreateOption } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.TITLE' | translate: { name: actionList.name } }}
    </h2>
    <mat-dialog-content>
      <p>
        <mat-form-field>
          <input
            matInput
            [placeholder]="'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.GROUP_REPORT_NAME' | translate"
            [(ngModel)]="brandReportName"
          />
        </mat-form-field>
      </p>
      <p>
        <mat-form-field>
          <mat-label>{{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.ORGANIZE_BY' | translate }}</mat-label>
          <mat-select [(ngModel)]="organizeBy" *ngIf="brandReportName">
            <mat-option [value]="'geo'">
              {{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.GEOGRAPHIC_REGION' | translate }}
            </mat-option>
            <mat-option [value]="'tag'">
              {{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.ACCOUNT_TAGS' | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </p>
      <p class="alert-warning">
        {{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.ALL_ACCOUNTS_WILL_BE_ADDED' | translate }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" [disabled]="!brandReportName" (click)="createBrandReport()">
        <ng-container *ngIf="!buttonLoading; else matSpinner">
          {{ 'ACTION_LISTS.CREATE_BRAND_REPORT_DIALOG.CREATE_REPORT' | translate }}
        </ng-container>
        <ng-template #matSpinner>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
})
export class CreateBrandReportDialogComponent extends ActionListDialogComponent implements OnInit {
  brandReportName: string;
  organizeBy: BrandCreateOption = 'geo';
  buttonLoading = false;

  constructor(
    public dialogRef: MatDialogRef<CreateBrandReportDialogComponent>,
    public router: Router,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  ngOnInit(): void {
    this.brandReportName = this.actionList.name;
  }

  createBrandReport(): void {
    if (this.buttonLoading) {
      return;
    }

    this.buttonLoading = true;
    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.createBrandReportFromList(
        this.actionList.id,
        this.actionList.name,
        this.brandReportName,
        this.organizeBy,
      );
    } else {
      response$ = this.actionsService.createBrandReportFromLegacyList(
        this.actionList.id,
        this.brandReportName,
        this.organizeBy,
      );
    }
    response$.subscribe({
      next: () => {
        this.snackbarService.successSnack(`Creating multi-location group report for ${this.actionList.name}.`);
        this.dialogRef.close(true);
        this.buttonLoading = false;
      },
      error: () => {
        this.snackbarService.errorSnack(
          `Failed to create multi-location group report from ${this.actionList.name}. Please try again.`,
        );
        this.buttonLoading = false;
      },
    });
  }
}
